

import { Routes, Route } from 'react-router-dom';
import sanga3 from "../assets/sanga5.jpg";
import { useState, useEffect } from 'react';
import axios from 'axios';
import shell from "../assets/sanga.webp"
import shell2 from "../assets/sanga3.jpg"
import shell3 from "../assets/star.webp"
import shell4 from "../assets/dolphin2.avif"
import star from "../assets/sanga4.jpg"
import jelly from "../assets/jelly5.jpg"
import jelly2 from "../assets/seashell6.jpg"
import dive13 from "../assets/gido (17).jpg"
import dive14 from "../assets/gido (18).jpg"
import dive15 from "../assets/gido (19).jpg"
import dive16 from "../assets/gido (20).jpg"
import dive17 from "../assets/gido (21).jpg"
import dive19 from "../assets/gido (23).jpg"
import dive20 from "../assets/gido (24).jpg"
import dive21 from "../assets/gido (25).jpg"
import dive22 from "../assets/gido (26).jpg"
import dive23 from "../assets/gido (27).jpg"
import dive24 from "../assets/gido (28).jpg"
import dive25 from "../assets/gido (29).jpg"
import dive26 from "../assets/gido (30).jpg"
import dive27 from "../assets/gido (31).jpg"
import dive28 from "../assets/gido (32).jpg"
import dive29 from "../assets/gido (33).jpg"
import dive30 from "../assets/gido (34).jpg"
import { useTranslation } from "react-i18next";
import { API_URL } from "../config";

export default function Sanganb() {
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const { t } = useTranslation();

  const images = [sanga3, shell, dive13, dive14, dive15, dive16, dive17
    , dive19, dive20, dive21, dive22, dive23, dive24, dive25, dive26, dive27, dive28, dive29, dive30
  ];
  const [preview, setPreview] = useState(null);
  const [formData, setFormData] = useState({
    firstname: "",
    people: "",
    phone: "",
    date: "",
    passport: null,
    tribname: "Sanganb"
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "passport" && files.length > 0) {
      setFormData({ ...formData, [name]: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firstname.trim() || !formData.people.trim() || !formData.phone.trim()
      || !formData.date.trim() || !formData.passport) {
      alert("فضلاً املئي كل الحقول");
      return;
    }

    const data = {
      firstname: formData.firstname,
      people: formData.people,
      phone: formData.phone,
      date: formData.date,
      passport: formData.passport?.name || "uploaded",
      tribname: formData.tribname
    };

    try {
      await axios.post(`${API_URL}/booking`, data);
      alert('تم الحجز بنجاح ✅');
      setFormData({ firstname: "", people: "", phone: "", date: "", passport: null, tribname: "Sanganb" });
      setPreview(null);
    }
    catch (err) {
      console.log(err);
      alert("حدث خطأ: " + (err.response?.data?.error || err.message));
    }
  };


  const [price, setPrice] = useState([]);
  useEffect(() => {
    async function getPrice() {
      try {
        const responce = await axios.get(`${API_URL}/prices`);
        setPrice(responce.data);
      }
      catch (error) {
        console.error(error)
      }
    } getPrice();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
  };
  return (

    <div className="bg-green-30">

      <div className="w-full h-full relative" >
        <img src={sanga3} className="hidden lg:block w-full h-full object-cover" />

        <div className='lg:absolute gap-6  inset-0 bg-black/40 flex  flex-col items-center justify-center lg:flex-row'>

          <img src={sanga3} className="lg:hidden w-full h-full absolute  top-0 object-cover " />

          <div data-aos="fade-right"
            className="lg:relative  flex items-center flex-col rtl h-full p-4 lg:m-6 justify-center" >
            <h1 className="text-white  text-6xl md:text-6xl font-bold">{t("sanganb")} </h1>
            <h3 className="text-white  text-xl md:text-xl font-bold p-4"> {t("hero2")}</h3>
          </div>

          <form onSubmit={handleSubmit} data-aos="fade-left"
            className="mx-4 rounded-[20px] w-full max-w-[500px]
  mx-w-md mx-auto mt-10 p-4  items-center 
 justify-center bg-black/50 text-white mb-0"  >
            <div className="space-y-12">
              {price.filter((el) => el.id === "1").map((item) => (<div className="border-b border-gray-900/10 justify-centet items-center">
                <h2 className="text-base/7 font-semibold text-white justify-center items-center">Book to Sanganb Trip </h2>

                <h2 className="text-base/7 font-semibold text-white justify-center items-center">${item.price}</h2>

                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                  <div className="sm:col-span-3">
                    <label htmlFor="first-name" className="block text-sm/6 font-medium ">{t("name")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} type='text' value={formData.firstname} id="first-name" name="firstname" autocomplete="given-name"
                        className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label htmlFor="email" className="block text-sm/6 font-medium ">{t("phone")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} id="email" type="tel" value={formData.phone} name="phone" autocomplete="phone" className="block border  w-full rounded-md bg-blue-100/50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300sm:text-sm/6" />
                    </div>
                  </div>


                  <div className="sm:col-span-3">
                    <label htmlFor="first-name" className="block text-sm/6 font-medium ">{t("date3")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} type='date' value={formData.date} id="first-name" name="date" autocomplete="given-name" className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label htmlFor="email" className="block text-sm/6 font-medium ">{t("people")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} id="email" type="text" value={formData.people} name="people" autocomplete="" className="block border  w-full rounded-md bg-blue-100/50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300sm:text-sm/6" />
                    </div>
                  </div>



                  <div className="sm:col-span-6">
                    <div className="border-b border-gray-900/10 pb-12">
                      <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="col-span-full">
                          <label htmlFor="cover-photo" className="block text-sm/6 font-medium">{t("photo")}</label>
                          <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25">
                            <div className="text-center">

                              <div className="mt-4 flex text-sm/6 text-gray-600">
                                <label htmlFor="file-upload" className="relative cursor-pointer rounded-md bg-white font-semibold
                 text-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 
    ]focus-within:outline-hidden hover:text-indigo-500">
                                  <span>Upload a file</span>
                                  <input type="file" name="passport" onChange={handleChange} accept='image/*' />
                                  {preview && (
                                    <img
                                      src={preview}
                                      alt="passport preview"
                                      className="mt-4 w-20 h-20 object-cover rounded-md"
                                    />
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>))}
            </div>

            <div className="mt-6 flex items-center justify-end gap-x-6">

              <button type="submit" className="rounded-md w-full bg-blue-400 px-3 py-2 text-sm font-semibold 
    text-white shadow-xs hover:bg-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2
     focus-visible:outline-blue-600">Send</button>
            </div>
          </form>


        </div>
      </div>

      {/* ////////////////////////////////////////////// */}
      <div className="hidden md:block my-6 relative w-full h-[100px] flex flex-col md:flex-row-reverse items-center  p-4 bg-white justify-center " >
        <img src={jelly} data-aos="fade-left" className=" absolute w-[100px] h-[100px] top-0 right-20" />
        <img src={shell3} data-aos="fade-right" className="absolute w-[100px] h-[100px]  top-0 left-20" />
      </div>
      <div className="h-[40%] my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div className='relative md:w-[50%] md:h-[40%] w-full '>
          <img src={sanga3} data-aos="fade-right" className="md:w-[80%] md:h-[40%] p-4 object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("sanganb")} </h2>
          <p className="text-gray-700 ">

            {t("sanganbs")} </p>

        </div>


      </div>
      <div className=" hidden md:block relative w-full h-[100px] flex flex-col md:flex-row-reverse items-center  p-4 bg-white justify-center " >
        <img src={shell4} data-aos="fade-left" className=" absolute w-[100px] h-[100px] top-0 right-20" />
        <img src={jelly2} data-aos="fade-right" className="absolute w-[100px] h-[100px]  top-0 left-20" />
      </div>
      {/* //////////////////////////////// */}



      <div className='w-full  my-10 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>Sanganb Galary</h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>

    </div>
  );

}

